export const LOADING_MODAL_TITLE = 'Hold up, the amend appointment page is just loading.';
export const LOADING_AFTER_AMENDING_MODAL_TITLE = 'Please wait while your appointment confirmation is processed.';
export const LOADING_MODAL_MESSAGE = 'This may take up to 1 min.';
